module.exports = __webpack_public_path__ + "img/export2.12b3fb99.png";